import { actionTypes as ActionTypes } from './actionTypes';

export { ActionTypes }

export const saveProfile = (profile) => ({
    type: ActionTypes.SAVE_PROFILE,
    domain : ActionTypes.DOMAIN,
    profile : profile
});